const addressConstants = {
  SET_ADDRESS: "SET_ADDRESS",
  RESET_ADDRESS: "RESET_ADDRESS",
};

export default addressConstants;
